module.exports = __webpack_public_path__ + "img/Frente-35-01 on.5d801a97.png";